// One firm's onboarding record (/admin/onboarding/:id): a link back to the firm list, then its review.
import { useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import type { PipelineRow } from '@upm/domain';
import { api } from '../lib/api';
import { useMe } from './AdminShell';
import type { DeletedState } from './Pipeline';
import { ReviewPanel } from './Review';

export function FirmRecordPage() {
  const { id } = useParams();
  const { reportPipeline } = useMe();
  const navigate = useNavigate();
  // The nav counts come from the firm list; a change here refreshes them.
  const refreshCounts = useCallback(async () => {
    try { reportPipeline(await api.get<PipelineRow[]>('/api/admin/onboardings')); }
    catch { /* the next list load corrects them */ }
  }, [reportPipeline]);
  return (
    <>
      <Link to="/admin/onboarding" className="-mb-1 inline-flex min-h-9 items-center gap-1.5 self-start text-sm font-semibold text-brand no-underline hover:underline">
        <ArrowLeft aria-hidden="true" size={16} />Firm onboarding
      </Link>
      <ReviewPanel key={id} id={id!} onChanged={refreshCounts}
        onDeleted={(firmName, result) => navigate('/admin/onboarding', { state: { deleted: { firmName, result } } satisfies DeletedState })} />
    </>
  );
}
